"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useScrollToEnd;

var _react = require("react");

var _useWebChatUIContext2 = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useScrollToEnd() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      scrollToEndCallbacksRef = _useWebChatUIContext.scrollToEndCallbacksRef;

  return (0, _react.useCallback)(function () {
    return scrollToEndCallbacksRef.current.forEach(function (callback) {
      return callback({
        behavior: 'smooth'
      });
    });
  }, [scrollToEndCallbacksRef]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTY3JvbGxUb0VuZC50cyJdLCJuYW1lcyI6WyJ1c2VTY3JvbGxUb0VuZCIsInNjcm9sbFRvRW5kQ2FsbGJhY2tzUmVmIiwiY3VycmVudCIsImZvckVhY2giLCJjYWxsYmFjayIsImJlaGF2aW9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUE7Ozs7QUFFZSxTQUFTQSxjQUFULEdBQXNDO0FBQ25ELDZCQUFvQyxvQ0FBcEM7QUFBQSxNQUFRQyx1QkFBUix3QkFBUUEsdUJBQVI7O0FBRUEsU0FBTyx3QkFBWTtBQUFBLFdBQU1BLHVCQUF1QixDQUFDQyxPQUF4QixDQUFnQ0MsT0FBaEMsQ0FBd0MsVUFBQUMsUUFBUTtBQUFBLGFBQUlBLFFBQVEsQ0FBQztBQUFFQyxRQUFBQSxRQUFRLEVBQUU7QUFBWixPQUFELENBQVo7QUFBQSxLQUFoRCxDQUFOO0FBQUEsR0FBWixFQUF5RyxDQUM5R0osdUJBRDhHLENBQXpHLENBQVA7QUFHRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ2FsbGJhY2sgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB1c2VXZWJDaGF0VUlDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdFVJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVNjcm9sbFRvRW5kKCk6ICgpID0+IHZvaWQge1xuICBjb25zdCB7IHNjcm9sbFRvRW5kQ2FsbGJhY2tzUmVmIH0gPSB1c2VXZWJDaGF0VUlDb250ZXh0KCk7XG5cbiAgcmV0dXJuIHVzZUNhbGxiYWNrKCgpID0+IHNjcm9sbFRvRW5kQ2FsbGJhY2tzUmVmLmN1cnJlbnQuZm9yRWFjaChjYWxsYmFjayA9PiBjYWxsYmFjayh7IGJlaGF2aW9yOiAnc21vb3RoJyB9KSksIFtcbiAgICBzY3JvbGxUb0VuZENhbGxiYWNrc1JlZlxuICBdKTtcbn1cbiJdfQ==